import { render } from "./AddPatients.vue?vue&type=template&id=4d0e03e9&scoped=true"
import script from "./AddPatients.vue?vue&type=script&lang=js"
export * from "./AddPatients.vue?vue&type=script&lang=js"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0e03e9"]])

export default __exports__